/**
 * A role which employee fulfills in the store.
 */
export enum EmployeeRoleEnum {
  /** A general manager of the store. */
  GENERAL_MANAGER = 'GENERAL_MANAGER',

  /** An assistant manager of the store, who supports the general manager. */
  ASSISTANT_MANAGER = 'ASSISTANT_MANAGER',

  /** A senior salesperson, which can take over extra responsibilities. */
  SENIOR_SALES_ADVISOR = 'SENIOR_SALES_ADVISOR',

  /** An ordinary salesperson. */
  SALES_ADVISOR = 'SALES_ADVISOR',

  /** A customer experience advisor. */
  CUSTOMER_EXPERIENCE_ADVISOR = 'CUSTOMER_EXPERIENCE_ADVISOR'
}
